import React, { useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import DocumentItem from '../DocumentItem/DocumentItem';
import { DocumentAction } from '../DocumentActions/DocumentActions';
import { DisplayedDocument } from '../../../providers/types';

export type DownloadableDocumentItemProps = {
    onDownload: () => void;
    onShow: () => void;
} & DisplayedDocument;

const DownloadableDocumentItem: React.FunctionComponent<DownloadableDocumentItemProps> = function (
    props,
) {
    const {
        onDownload: handleDownload,
        label,
        fileName,
        type,
        showable,
        downloadable,
        onShow,
    } = props;
    const [isMouseHover, setIsMouseHover] = useState<number>(0);
    const { palette } = useTheme();
    const actions: Array<DocumentAction> = [];
    const handleMouseEnter = () => setIsMouseHover((val) => val + 1);
    const handleMouseLeave = () => setIsMouseHover((val) => val - 1);
    const actionIconSx = {
        fontWeight: '400',
        fontSize: '16px',
        lineHeight: '16px',
        ':hover': { color: 'text.secondary' },
    };

    if (showable) {
        actions.push({
            title: 'Afficher le document',
            content: (
                <FaOptionIcon
                    icon={['fasl', 'eye']}
                    color="text.gris35"
                    sx={actionIconSx}
                />
            ),
            onClick: (e) => {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                onShow();
            },
        });
    }

    if (downloadable) {
        actions.push({
            title: 'Télécharger le document',
            content: (
                <FaOptionIcon
                    icon={['fasl', 'arrow-down-to-line']}
                    color="text.gris35"
                    sx={actionIconSx}
                />
            ),
            onClick: () => {
                handleDownload();
            },
        });
    }

    return (
        <Box
            data-testid="downloadable-documents-item"
            onClick={handleDownload}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <DocumentItem
                label={label as string}
                fileName={fileName}
                type={type}
                hover={isMouseHover > 0}
                showUploadBtn={false}
                uploadable={false}
                uploading={false}
                color="primary"
                sx={{ cursor: 'pointer' }}
                labelSx={{ color: palette.primary.dark }}
                actions={actions}
            />
        </Box>
    );
};

export default DownloadableDocumentItem;
